import { render, staticRenderFns } from "./CompensationTypeEditor.vue?vue&type=template&id=48d1e090"
import script from "./CompensationTypeEditor.vue?vue&type=script&lang=js"
export * from "./CompensationTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports